import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Screen_ET_ET from '../assets/img/question_4/et_et.png';
import Screen_ET_RU from '../assets/img/question_4/et_ru.png';
import Screen_LT_LT from '../assets/img/question_4/lt_lt.png';
import Screen_LV_LV from '../assets/img/question_4/lv_lv.png';
import Screen_LV_RU from '../assets/img/question_4/lv_ru.png';
import useGame from '../hooks/useGame';

const SecurityExpertQ4 = ({ text, imageDesktop, imageMobile }) => {

  const { t } = useTranslation();
  const { REACT_APP_LANGUAGE } = process.env;
  const { language } = useGame();

  const [screen, setScreen] = useState(Screen_ET_ET);

  // switch the image based on domain and language
  useEffect(() => {
    if (REACT_APP_LANGUAGE === 'et' && language === 'et') {
      setScreen(Screen_ET_ET);
    }
    if (REACT_APP_LANGUAGE === 'et' && language === 'ru') {
      setScreen(Screen_ET_RU);
    }
    if (REACT_APP_LANGUAGE === 'lt' && language === 'lt') {
      setScreen(Screen_LT_LT);
    }
    if (REACT_APP_LANGUAGE === 'lv' && language === 'lv') {
      setScreen(Screen_LV_LV);
    }
    if (REACT_APP_LANGUAGE === 'lv' && language === 'ru') {
      setScreen(Screen_LV_RU);
    }
  }, [REACT_APP_LANGUAGE, language]);

  return (
    <div className="security-expert helper-screen">

      <div role='button' tabIndex={-1} className="helper-button">
        <div className="inner-wrap">
          <div className="the-icon">
            <span className="icon expert" />
            <p>{t('expert.button')}</p>
          </div>
        </div>
      </div>

      <div className="helper-text">
        <span style={{ display: 'none' }} className="icon close-helper" />
        <div className="inner-wrap">

          <div className="image">
            <img src={screen} alt="" />
            <h2>{t('expert.original')}</h2>
          </div>

          <div className="info">
            <div className="top">
              <div className={`expert-image ${REACT_APP_LANGUAGE.toLowerCase()}`} />
              <div className="expert-info">
                <h4>{t('expert.title')}</h4>
                <h3>{t(`expert.name.${REACT_APP_LANGUAGE.toLowerCase()}`)}</h3>
              </div>
            </div>
            <div style={{ display: 'none' }} tabIndex={0} className="text" 
              id="expert-scroll"
            >
              <div className="flex-wrap">
                {REACT_APP_LANGUAGE === 'lt' && (
                  <p>„{text}“</p>
                )}
                {REACT_APP_LANGUAGE !== 'lt' && (
                  <p>"{text}"</p>
                )}
                <div className="btm-wrap">
                  <h3 className="title-mobile">{t('expert.original')}</h3>
                  <img className="mobile_correct" src={imageMobile} data-full={imageMobile} alt="" />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SecurityExpertQ4;
